<nz-card>
  <p *ngIf="sellerRole" [innerHTML]="sellerRole | htmlBypass"></p>

  <div *ngIf="accreditationRequirements">
    <h3>Requirements</h3>
    <p [innerHTML]="accreditationRequirements | htmlBypass"></p>
  </div>

  <div *ngIf="accreditationProcess">
    <h3>Steps To Follow</h3>
    <p [innerHTML]="accreditationProcess | htmlBypass"></p>
  </div>

  <div *ngIf="trainerRequirements">
    <h3>Trainer Requirements</h3>
    <p [innerHTML]="trainerRequirements | htmlBypass"></p>
  </div>

  <div *ngIf="examInformation">
    <h3>Exam Information</h3>
    <p [innerHTML]="examInformation | htmlBypass"></p>
  </div>

  <div *ngIf="sellerAccreditationStatus">
    <h3>Seller Accreditation Status</h3>
    <p [innerHTML]="sellerAccreditationStatus | htmlBypass"></p>
  </div>
  <div *ngIf="accreditationSegments">
    <h3>Start Here</h3>
    <p>Please select an option below to start the process of becoming a:</p>
    <div nz-row *ngFor="let segment of accreditationSegments" class="segment-information-row">
      <leap-segment-information
        [segment]="segment"
        [segmentsMapper]="segmentsMapper"
        (getAccess)="getAccess.emit($event)"></leap-segment-information>
    </div>
  </div>
</nz-card>
